import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './styles/style.css'
import './styles/toolbar-menus.css'
import './styles/list-markers.css'
import './assets/ink-symbols.css'
import './styles/bar-keys.css'
import './styles/caret.css'
import './styles/corpus-panel.css'
import { initPlatformBridge } from './services/platform/platformBridge'
import { useFontsStore } from './stores/fonts'
import { startUpdateManager } from './services/platform/updateManager'
import AppGate from './AppGate.vue'
import { startToolColors } from './services/theme/toolColors'
import { IS_MOBILE_APP } from './utils/appVariant'
import { installKeyboardNav } from './utils/keyboardNav'

initPlatformBridge().then(() => {
  installKeyboardNav()
  const app = createApp(AppGate, { mobile: IS_MOBILE_APP })
  const pinia = createPinia()
  app.use(pinia)
  void useFontsStore(pinia).initializeCatalogFonts().catch((error) => {
    console.warn('[FontCatalog] Boot rehydration failed:', error)
  })
  startToolColors(pinia)
  app.mount('#app')
  startUpdateManager()
})
